/** Resposta binária (Sim / Não). */
export type ProntuarioYesNo = 'SIM' | 'NAO';

/** Realização da tarefa combinada na sessão anterior. */
export type ProntuarioTaskCompletion = 'SIM' | 'NAO' | 'PARCIALMENTE';

/** Nível de engajamento na sessão. */
export type ProntuarioEngagementLevel = 'BAIXO' | 'BOM' | 'MUITO_BOM';

/** Presença do paciente na sessão. */
export type ProntuarioPresenceStatus = 'PRESENTE' | 'FALTOU' | 'CANCELADO';

export type ProntuarioSessionChoiceValue =
	| ProntuarioYesNo
	| ProntuarioTaskCompletion
	| ProntuarioEngagementLevel
	| ProntuarioPresenceStatus;

export type ProntuarioSessionFieldKind =
	| 'text'
	| 'yes_no'
	| 'task_completion'
	| 'engagement'
	| 'presence';

type ChoiceOption<T extends string> = {
	value: T;
	label: string;
};

export const PRONTUARIO_YES_NO_OPTIONS: ReadonlyArray<
	ChoiceOption<ProntuarioYesNo>
> = [
	{ value: 'SIM', label: 'Sim' },
	{ value: 'NAO', label: 'Não' },
];

export const PRONTUARIO_TASK_COMPLETION_OPTIONS: ReadonlyArray<
	ChoiceOption<ProntuarioTaskCompletion>
> = [
	{ value: 'SIM', label: 'Sim' },
	{ value: 'PARCIALMENTE', label: 'Parcialmente' },
	{ value: 'NAO', label: 'Não' },
];

export const PRONTUARIO_ENGAGEMENT_OPTIONS: ReadonlyArray<
	ChoiceOption<ProntuarioEngagementLevel>
> = [
	{ value: 'BAIXO', label: 'Baixo' },
	{ value: 'BOM', label: 'Bom' },
	{ value: 'MUITO_BOM', label: 'Muito bom' },
];

export const PRONTUARIO_PRESENCE_OPTIONS: ReadonlyArray<
	ChoiceOption<ProntuarioPresenceStatus>
> = [
	{ value: 'PRESENTE', label: 'Presente' },
	{ value: 'FALTOU', label: 'Faltou' },
	{ value: 'CANCELADO', label: 'Cancelado' },
];

const CHOICE_LABELS: Record<ProntuarioSessionChoiceValue, string> = {
	SIM: 'Sim',
	NAO: 'Não',
	PARCIALMENTE: 'Parcialmente',
	BAIXO: 'Baixo',
	BOM: 'Bom',
	MUITO_BOM: 'Muito bom',
	PRESENTE: 'Presente',
	FALTOU: 'Faltou',
	CANCELADO: 'Cancelado',
};

export const getProntuarioSessionChoiceOptions = (
	kind: Exclude<ProntuarioSessionFieldKind, 'text'>,
) => {
	switch (kind) {
		case 'yes_no':
			return PRONTUARIO_YES_NO_OPTIONS;
		case 'task_completion':
			return PRONTUARIO_TASK_COMPLETION_OPTIONS;
		case 'engagement':
			return PRONTUARIO_ENGAGEMENT_OPTIONS;
		case 'presence':
			return PRONTUARIO_PRESENCE_OPTIONS;
	}
};

export const formatProntuarioSessionChoiceLabel = (
	value: string | null | undefined,
): string | null => {
	if (!value?.trim()) return null;
	return CHOICE_LABELS[value as ProntuarioSessionChoiceValue] ?? null;
};

export const isProntuarioSessionChoiceValue = (
	value: string,
	kind: Exclude<ProntuarioSessionFieldKind, 'text'>,
): boolean =>
	getProntuarioSessionChoiceOptions(kind).some(
		(option) => option.value === value,
	);
